import React from 'react'
import { Text } from 'react-native'
import { InfoModal } from '../ui/InfoModal'
import { useNow } from '../../hooks/useNow'
import { vacationRemainingSentence } from '../../lib/vacation'

export interface VacationDetails { name: string; endsAt: string; message: string | null }

export function VacationDetailsModal({ vacation, onClose }: { vacation: VacationDetails | null; onClose: () => void }) {
  const now = useNow(vacation ? 60_000 : null)
  return <InfoModal visible={vacation !== null} title={`${vacation?.name ?? 'Player'} is on vacation`}
    message={vacation ? `${vacationRemainingSentence(vacation.name, vacation.endsAt, now)}${vacation.message ? `\n\n${vacation.message}` : ''}` : ''}
    onClose={onClose}>
    {vacation && <Text className="font-typed text-ink text-sm">
      {vacation.name} can’t be booted for inactivity or replaced by a bot while vacation mode is on. Their current turn timer starts fresh when vacation mode ends, or when they turn it off early.
    </Text>}
  </InfoModal>
}
